import React from 'react';
import dayjs, { type Dayjs } from 'dayjs';
import { noop } from 'lodash';

import PageHeader, { PageBackground } from '@domain/page-header';
import DobFeature from '@features/dob';
import { useElearningWpOnSiteBirthDate } from '@services/elearning-wp-onsite';
import { useElearningWpOnSiteFlow } from './shared/ewos-flow-context';

function ElearningWpOnSiteDobPage() {
  const { mutateAsync, isPending } = useElearningWpOnSiteBirthDate();
  const { goBack } = useElearningWpOnSiteFlow();

  const onSubmit = async ({ birthDate }: { birthDate: Dayjs | string }) => {
    const formatted = dayjs(birthDate).format('YYYY-MM-DD');
    await mutateAsync({ birthDate: formatted }).catch(noop);
  };

  return (
    <PageBackground>
      <PageHeader />
      <DobFeature onSubmit={onSubmit} isPending={isPending} onBack={goBack} />
    </PageBackground>
  );
}

export default ElearningWpOnSiteDobPage;
